import React from "react";
import "./LegalPage.css";
import LegalPage from "./LegalPage";

export default function Terms() {
    return <LegalPage ns="terms" />;
}
